import { Spin } from "antd";
import { forwardRef } from "react";
import { space } from "styled-system";
import styled from "styled-components";
import "./style/index.css?global";
import { jsx as _jsx } from "react/jsx-runtime";
export const Container = styled.div.withConfig({
  displayName: "spinner__Container",
  componentId: "sc-79rq72-0"
})(["text-align:center;", " .ant-spin-container{&::after{background:", ";}}&[data-mask=\"true\"]{width:100%;height:100%;position:absolute;top:0;left:0;background-color:", ";z-index:1;.ant-spin{display:flex;align-items:center;justify-content:center;height:100%;}}"], space, p => p.theme.colors.bg.component, p => p.theme.colors.alpha.inverse[6]);
const Spinner = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    show = true,
    mask = false,
    spinning = true,
    size = "default",
    children,
    ...rest
  } = _ref;
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_jsx(Container, {
    ref: ref,
    ...rest,
    "data-mask": mask,
    children: /*#__PURE__*/_jsx(Spin, {
      spinning: spinning,
      size: size,
      children: children
    })
  });
});
export default Spinner;